import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { SEL, uploadFile } from "@/components/employes/shared";

export const DocumentDialog = ({ types, labels, employes, onClose, onSaved }) => {
  const [v, setV] = useState({ employe_id: "", type: types[0], titre: "", date_document: "", date_expiration: "", periode: "" });
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setV({ ...v, [k]: e.target.value });
  const paie = v.type === "fiche_paie";

  const save = async () => {
    if (!v.employe_id || !v.date_document) return toast.error("Employé et date obligatoires");
    setSaving(true);
    try {
      const f = await uploadFile(file);
      await api.post("/employes/documents", { ...v, ...f, date_expiration: v.date_expiration || null, periode: v.periode || null });
      toast.success("Document ajouté");
      onSaved();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur d'enregistrement");
    } finally {
      setSaving(false);
    }
  };

  const field = (k, l, type = "text") => (
    <label className="text-xs text-muted-foreground space-y-1">{l}
      <Input type={type} value={v[k]} onChange={set(k)} data-testid={`doc-input-${k}`} />
    </label>
  );

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-card" data-testid="doc-dialog">
        <DialogHeader><DialogTitle>Nouveau document</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <label className="text-xs text-muted-foreground space-y-1 col-span-2">Employé
            <select className={SEL} value={v.employe_id} onChange={set("employe_id")} data-testid="doc-input-employe">
              <option value="">— Choisir —</option>
              {employes.map((e) => <option key={e.id} value={e.id}>{e.nom} {e.prenom} — {e.societe_nom}</option>)}
            </select>
          </label>
          {types.length > 1 && <label className="text-xs text-muted-foreground space-y-1 col-span-2">Type
            <select className={SEL} value={v.type} onChange={set("type")} data-testid="doc-input-type">
              {types.map((t) => <option key={t} value={t}>{labels[t]}</option>)}
            </select>
          </label>}
          {field("titre", "Intitulé (facultatif)")}
          {field("date_document", "Date du document", "date")}
          {paie ? field("periode", "Mois de paie", "month") : field("date_expiration", "Date d'expiration (facultatif)", "date")}
          <label className="text-xs text-muted-foreground space-y-1 col-span-2">Fichier (PDF ou image)
            <Input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={(e) => setFile(e.target.files[0] || null)} data-testid="doc-input-file" />
          </label>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} data-testid="doc-cancel">Annuler</Button>
          <Button onClick={save} disabled={saving} data-testid="doc-save">Enregistrer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
